module.exports = __webpack_public_path__ + "img/logo.e77802cf.png";